import React from 'react';
import { RepType } from 'types';
import { Exercise } from '../Exercise';
import { ExerciseChip } from '../ExerciseChip';

export interface PerisurgicalExerciseProps {
  uuid: string;
  name: string;
  anatomicalName?: string | null;
  reps: number;
  holdTime: number;
  thumbnailUrl?: string;
  repType?: RepType | null;
}

export const PerisurgicalExercise = ({
  uuid,
  name,
  anatomicalName,
  reps,
  holdTime,
  thumbnailUrl,
  repType
}: PerisurgicalExerciseProps): JSX.Element => (
  <Exercise
    name={name}
    id={uuid}
    thumbnailUrl={thumbnailUrl}
    anatomicalName={anatomicalName}
  >
    <ExerciseChip label="reps" value={reps} repType={repType} />
    <ExerciseChip label="sec hold" value={holdTime / 1000} />
  </Exercise>
);
